/**
 * Mega menu – swap des produits au survol des sous-catégories
 * mychatelles.com – Savor v3.5.1
 */

// Cache : { handle: { html, imageSrcs[] } }
const productsCache = new Map();
let currentCollectionUrl = null;
const preloadedHandles = new Set();

// --- Préchargement au hover du menu principal ---
// Déclenché dès qu'on survole FEMMES, HOMMES... (intent-based)
document.addEventListener('mouseover', (event) => {
  const topLink = event.target.closest('.menu-list__link');
  if (!topLink) return;
  const listItem = topLink.closest('.menu-list__list-item');
  if (!listItem) return;

  // Trouver tous les liens de collection dans ce sous-menu
  const links = listItem.querySelectorAll('.mega-menu__link[href*="/collections/"]');
  links.forEach((link) => {
    const match = link.href.match(/\/collections\/([^?#]+)/);
    if (match) {
      const handle = match[1].replace(/\/+$/, '');
      if (!preloadedHandles.has(handle)) {
        preloadedHandles.add(handle);
        fetchAndCache(handle);
      }
    }
  });
}, true);

// Fallback : si le menu n'est pas encore hydraté au hover, observer le DOM
function observeAndPreload() {
  const observer = new MutationObserver(() => {
    const links = document.querySelectorAll('.mega-menu__grid .mega-menu__link[href*="/collections/"]');
    if (links.length === 0) return;
    observer.disconnect();
    links.forEach((link) => {
      const match = link.href.match(/\/collections\/([^?#]+)/);
      if (match) {
        const handle = match[1].replace(/\/+$/, '');
        if (!preloadedHandles.has(handle)) {
          preloadedHandles.add(handle);
          fetchAndCache(handle);
        }
      }
    });
  });
  observer.observe(document.querySelector('header-menu') || document.body, {
    childList: true, subtree: true,
  });
}
window.addEventListener('load', observeAndPreload);

// Fetch products for a collection path like "slippers-1" or "slippers-1/femme".
// /collections/{handle}/{tag} is a storefront-only URL — the API doesn't support it,
// so we fetch the base collection and filter by tag client-side.
async function fetchCollectionProducts(collectionPath) {
  const slashIdx = collectionPath.indexOf('/');
  const baseHandle = slashIdx === -1 ? collectionPath : collectionPath.slice(0, slashIdx);
  const tagFilter = slashIdx === -1 ? null : collectionPath.slice(slashIdx + 1).toLowerCase();
  const limit = 100;

  const response = await fetch(`/collections/${baseHandle}/products.json?limit=${limit}`);
  if (!response.ok) return null;

  const data = await response.json();
  let products = data.products;
  if (!products || products.length === 0) return null;

  if (tagFilter) {
    const filtered = products.filter((p) => {
      if (!p.tags) return false;
      return p.tags.some((t) => t.trim().toLowerCase() === tagFilter);
    });
    // Si le tag matche : produits filtrés ; sinon : premiers produits de la collection (bonne catégorie, mauvais genre)
    products = filtered.length > 0 ? filtered : products;
  }

  return products.slice(0, 3);
}

async function fetchAndCache(collectionPath) {
  if (productsCache.has(collectionPath)) return;

  try {
    const products = await fetchCollectionProducts(collectionPath);
    if (!products || products.length === 0) return;

    const imageSrcs = products
      .map((p) => p.images[0]?.src.replace(/(\.\w+)$/, '_400x$1'))
      .filter(Boolean);

    productsCache.set(collectionPath, {
      html: buildProductsHtml(products),
      imageSrcs,
    });

    preloadImages(imageSrcs);

  } catch (err) {
    // Silencieux
  }
}

// Précharge les images via des balises <link rel="preload">
function preloadImages(srcs) {
  srcs.forEach((src) => {
    if (document.querySelector(`link[rel="preload"][href="${src}"]`)) return;
    const link = document.createElement('link');
    link.rel = 'preload';
    link.as = 'image';
    link.href = src;
    document.head.appendChild(link);
  });
}

// --- Survol des sous-catégories ---
document.addEventListener('mouseover', handleMegaMenuHover, true);

function handleMegaMenuHover(event) {
  const link = event.target.closest('.mega-menu__link');
  if (!link) return;

  const megaGrid = link.closest('.mega-menu__grid');
  if (!megaGrid) return;

  const productsPanel = megaGrid.querySelector('.mega-menu__content');
  if (!productsPanel) return;

  const collectionUrl = link.href;
  if (!collectionUrl || !collectionUrl.includes('/collections/')) return;
  if (collectionUrl === currentCollectionUrl) return;

  currentCollectionUrl = collectionUrl;

  if (!megaGrid.dataset.originalProducts) {
    megaGrid.dataset.originalProducts = productsPanel.innerHTML;
  }

  const match = collectionUrl.match(/\/collections\/([^?#]+)/);
  if (!match) return;
  const handle = match[1].replace(/\/+$/, '');

  if (productsCache.has(handle)) {
    // Instantané depuis le cache
    productsPanel.innerHTML = productsCache.get(handle).html;
  } else {
    // Pas encore en cache : fetch live
    fetchAndDisplayLive(handle, productsPanel, megaGrid);
  }
}

async function fetchAndDisplayLive(collectionPath, productsPanel, megaGrid) {
  try {
    const products = await fetchCollectionProducts(collectionPath);
    if (!products || products.length === 0) {
      productsPanel.innerHTML = megaGrid.dataset.originalProducts || '';
      return;
    }

    const imageSrcs = products
      .map((p) => p.images[0]?.src.replace(/(\.\w+)$/, '_400x$1'))
      .filter(Boolean);

    const cached = { html: buildProductsHtml(products), imageSrcs };
    productsCache.set(collectionPath, cached);
    preloadImages(imageSrcs);
    productsPanel.innerHTML = cached.html;
  } catch (err) {
    productsPanel.innerHTML = megaGrid.dataset.originalProducts || '';
  }
}

// Restaurer au départ du mega menu
document.addEventListener('mouseover', (event) => {
  if (!event.target.closest('.mega-menu__grid')) {
    currentCollectionUrl = null;
    document.querySelectorAll('.mega-menu__grid[data-original-products]').forEach((grid) => {
      const panel = grid.querySelector('.mega-menu__content');
      if (panel) panel.innerHTML = grid.dataset.originalProducts;
    });
  }
}, true);

// --- Helpers ---
function buildProductsHtml(products) {
  const cardsHtml = products.map((product) => {
    const image = product.images[0];
    const imgSrc = image ? image.src.replace(/(\.\w+)$/, '_400x$1') : '';
    const price = formatMoney(product.variants[0]?.price);
    const comparePrice = product.variants[0]?.compare_at_price;
    const productUrl = `/products/${product.handle}`;

    return `
      <li class="mega-menu__content-list-item">
        <div class="resource-card">
          <a href="${productUrl}" class="resource-card__media-link">
            <div class="resource-card__media" style="aspect-ratio:4/5; overflow:hidden; border-radius:var(--resource-card-corner-radius,0px);">
              ${imgSrc ? `<img src="${imgSrc}" alt="${escapeHtml(product.title)}" loading="eager" style="width:100%; height:100%; object-fit:cover; transition:transform 0.4s ease;">` : ''}
            </div>
          </a>
          <div class="resource-card__info">
            <a href="${productUrl}" class="resource-card__title">
              <span>${escapeHtml(product.title)}</span>
            </a>
            <div class="resource-card__price">
              ${comparePrice && comparePrice > product.variants[0].price
                ? `<span class="price price--sale">${price}</span><s class="price price--compare">${formatMoney(comparePrice)}</s>`
                : `<span class="price">${price}</span>`
              }
            </div>
          </div>
        </div>
      </li>
    `;
  }).join('');

  return `<ul class="mega-menu__content-list mega-menu__content-list--products list-unstyled">${cardsHtml}</ul>`;
}

function formatMoney(euro) {
  if (!euro) return '';
  return `${parseInt(euro).toFixed(2).replace('.', ',')}&nbsp;€`;
}

function escapeHtml(str) {
  return str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}

// --- Transparence du header après scroll ---
(function () {
  const header = document.getElementById('header-component');
  if (!header) return;

  function updateHeaderBg() {
    if (window.scrollY > header.offsetHeight) {
      document.body.classList.add('header-scrolled-past');
    } else {
      document.body.classList.remove('header-scrolled-past');
    }
  }

  window.addEventListener('scroll', updateHeaderBg, { passive: true });
  updateHeaderBg();
})();